import { configureStore } from "@reduxjs/toolkit";
// import { thunk, ThunkMiddleware } from "redux-thunk"; // <-- REMOVE THIS IMPORT
import rootReducer from "./root.reducer"; // Your combined reducers

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
